import { CContainer, CRow } from '@coreui/react';
import { useContext, useEffect } from 'react';
import useSWRImmutable from 'swr/immutable';

import AWSContext from '@/context/AWSContext.jsx';

import { loadCachedUserData } from '@/utils/helpers.js';

import { useLocationStore, usePrismicStore, useProfessionalsStore } from '@/zustandStore.js';

import PractitionersOnboarding from '../practitioners-onboarding/PractitionersOnboarding.jsx';

const Professionals = () => {
    const awsContext = useContext(AWSContext);
    const { userToken } = awsContext;
    const consentFormDocuments = usePrismicStore((state) => state.consentFormDocuments);
    const professionalsPrismicData = usePrismicStore((state) => state.professionals);
    const currentCustomer = usePrismicStore((state) => state.currentCustomer);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);
    const cachedUserData = useProfessionalsStore((state) => state.cachedUserData);
    const lightMappings = useProfessionalsStore((state) => state.lightMappings);

    useSWRImmutable(
        !cachedUserData || currentCustomer?.customer_id?.[0]?.text
            ? ['professionals', currentCustomer?.customer_id?.[0]?.text]
            : null,
        async () => loadCachedUserData(userToken)
    );

    const getProfessionalsData = () => {
        const instanceIdSet = new Set(selectedLocation.instanceIds);

        const templates = consentFormDocuments
            .filter((document) => document.tags.includes('doctor'))
            .map((a) => {
                return {
                    data: a.data,
                    lan: a.data,
                    key: a.data.key[0].text,
                    label: a.data.template_name[0].text,
                    value: a.data.key[0].text,
                };
            });

        const professionalsArray = cachedUserData
            .map((userData) => ({
                ...userData,
                ...professionalsPrismicData[userData.prismic_profile?.data?.key[0]?.text],
                ...userData.prismic_profile,
            }))
            .filter(
                (item) =>
                    item.prismic_customer_config.data.customer_id[0].text === currentCustomer.customer_id[0].text &&
                    instanceIdSet.has(item.instanceId)
            );

        const filteredLightMappings = Object.values(lightMappings)
            .filter((mapping) => instanceIdSet.has(mapping.dc_instance_id))
            .map((mapping) => ({
                ...mapping,
                dc_user_mapping: {
                    ...mapping,
                },
                userId: mapping.user_id,
                data: { ...professionalsPrismicData[mapping.prismic_key] },
            }));

        useProfessionalsStore.setState({
            templateArray: templates,
            finalRecords: [...professionalsArray, ...filteredLightMappings],
            childData: professionalsArray[0],
        });
    };

    useEffect(() => {
        if (
            !cachedUserData ||
            !consentFormDocuments ||
            !professionalsPrismicData ||
            !currentCustomer ||
            !lightMappings
        ) {
            return;
        }
        getProfessionalsData();
    }, [cachedUserData, professionalsPrismicData, consentFormDocuments, selectedLocation, lightMappings]);

    return (
        <CContainer className="pt-5">
            <CRow xs={{ gutterY: 2 }}>
                <PractitionersOnboarding />
            </CRow>
        </CContainer>
    );
};

export default Professionals;
